import React from 'react';
import { motion } from 'framer-motion';

const TestimonialsSection = ({ testimonials = [] }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  const renderStars = (rating) => {
    return '⭐'.repeat(rating);
  };

  return (
    <section className="py-24 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-900 border-y border-amber-500/20 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-amber-500/5 rounded-full filter blur-3xl opacity-20" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-amber-500/5 rounded-full filter blur-3xl opacity-20" />

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Trusted by Thousands
          </h2>
          <p className="text-gray-400 text-lg">
            See what our satisfied customers have to say about their experience with Ceylon Broker
          </p>
        </motion.div>

        {testimonials && testimonials.length > 0 ? (
          <motion.div
            className="grid md:grid-cols-3 gap-8"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {testimonials.map((testimonial, idx) => (
              <motion.div
                key={idx}
                variants={itemVariants}
                whileHover={{ y: -10 }}
                className="group relative"
              >
                {/* Glass morphism card */}
                <div className="absolute inset-0 bg-gradient-to-br from-amber-500/10 to-amber-500/5 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-all duration-500" />
                
                <div className="relative bg-slate-800/50 backdrop-blur-xl rounded-2xl p-8 border border-amber-500/20 group-hover:border-amber-500/40 transition-all duration-500">
                  {/* Quote mark */}
                  <div className="text-4xl text-amber-400/30 mb-4">"</div>

                  {/* Testimonial text */}
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {testimonial.testimonial_text}
                  </p>

                  {/* Rating */}
                  <div className="mb-4 text-lg">
                    {renderStars(testimonial.rating || 5)}
                  </div>

                  {/* Client info */}
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white font-bold text-lg">
                      {testimonial.client_name?.charAt(0) || 'U'}
                    </div>
                    <div>
                      <p className="font-semibold text-white">
                        {testimonial.client_name}
                      </p>
                      <p className="text-sm text-amber-300">
                        {testimonial.client_title}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center text-gray-400"
          >
            <p>No testimonials available yet. Check back soon!</p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default TestimonialsSection;
